import { createStore } from '@xstate/store';

export interface PanZoomStoreContext {
  panX: number;
  panY: number;
  zoom: number;
}

export function createPanZoomStore() {
  return createStore({
    context: {
      panX: 0,
      panY: 0,
      zoom: 1,
    } as PanZoomStoreContext,

    on: {
      set: (ctx, event: { panX: number; panY: number; zoom: number }) => ({
        ...ctx,
        panX: event.panX,
        panY: event.panY,
        zoom: event.zoom,
      }),
    },
  });
}

export type CanvasPanZoomStore = ReturnType<typeof createPanZoomStore>;
